var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{
    'tabs-title': true,
    'is-active': _vm.active,
  }},[_c('a',{on:{"click":_vm.onTabClick}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n    "),(_vm.showBadge)?_c('div',{staticClass:"badge"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.getItemCount)+"\n      ")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }